import { render, staticRenderFns } from "./msPagination.vue?vue&type=template&id=2f29dc32&scoped=true"
import script from "./msPagination.vue?vue&type=script&lang=js"
export * from "./msPagination.vue?vue&type=script&lang=js"
import style0 from "./msPagination.vue?vue&type=style&index=0&id=2f29dc32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f29dc32",
  null
  
)

export default component.exports